import { addSeconds } from 'date-fns/addSeconds';
import { differenceInSeconds } from 'date-fns/differenceInSeconds';

import { SubmittedAtTime } from 'domains/reporter/Reporter/Fields/types';

export const SUBMIT_TIME_LIMIT = 180; // 3 minutes

export function getExpectedSentAtFromSubmittedAt(
  submittedAt: Nullable<SubmittedAtTime>
): Date | null {
  if (submittedAt == null) {
    return null;
  }

  return addSeconds(new Date(submittedAt), SUBMIT_TIME_LIMIT);
}

export function getCountdownSeconds(expectedSentAt: Nullable<SubmittedAtTime>): number | null {
  if (expectedSentAt == null) {
    return null;
  }

  return differenceInSeconds(new Date(expectedSentAt), new Date());
}
